import logo from './logo.svg';
import './App.css';
import Form from './components/Form';
import Note from './components/Note';
import Bookmark from './components/Bookmark';
import AllRoutes from './Routes/AllRoutes';
import Navbar from './components/Navbar';

function App() {
  return (
    <div className="App">
    <AllRoutes/>
    </div>
  );
}

export default App;
